<template>
  <div>
    <b-navbar toggleable="md" type="dark" variant="info" class="pt-0 pb-0">
        <b-navbar-toggle target="nav_collapse_actions"></b-navbar-toggle>
        <!--
        <span style="font-size: 12px" class="text-center navbar-brand pt-0 pb-0 mb-0">{{ titulo }}</span>
        -->
        <!-- Right aligned nav items -->
        <b-navbar-nav >
          <b-nav-item-dropdown v-if="agenda_disponible" :text="titulo_dia" >
            <b-dropdown-item v-for="dia in agenda_disponible" :key="dia.timestamp" href="#" 
            @click="cambiarDia(dia)">
            {{ dia.texto }}
          </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
        
        <b-collapse is-nav id="nav_collapse_actions" >
          <b-navbar-nav  v-if="dia_actual" class="ml-auto">
            <b-nav-item  href="#" @click="recargarTutorias"><icon  name="sync-alt"></icon></b-nav-item>
<!--
            <b-nav-item  href="#" @click="toogleRightPanel" :active="rightPanel">Solicitudes</b-nav-item>
-->
          </b-navbar-nav>
        </b-collapse>
        
    </b-navbar>
  	<div class="container-fluid principal" >
  		
  				<div v-if="iniciado">
            <TutoriaDetalle :fecha_texto="dia_actual.fecha" />
  				</div>
  			
  	</div>
    <b-modal  no-close-on-esc no-close-on-backdrop hide-header-close v-model="agendando"  hide-footer id="modalprogramador" title="Nuevo Agendamiento">
      <ProgramadorProgramador v-if="dia_actual && hora_actual" :dia="dia_actual" :hora="hora_actual"/>
    </b-modal>

    <b-modal  no-close-on-esc no-close-on-backdrop hide-header-close v-model="creando_clase"  hide-footer id="modalclase" title="Nueva Clase">
      <ProgramadorNuevaClase :clase="nueva_clase" />
    </b-modal>

  </div>
</template>

<script>
  import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
  import TutoriaDetalle from '@/components/Tutoria/TutoriaDetalle';
  import ProgramadorProgramador from '@/components/Programador/ProgramadorProgramador';
  import ProgramadorNuevaClase from '@/components/Programador/ProgramadorNuevaClase';
  import Icon from 'vue-awesome/components/Icon'
  import 'vue-awesome/icons/sync-alt'
  import 'vue-awesome/icons/plus'
  import Vue from 'vue';

  export default {
    name: 'Tutoria',
    components: {
      TutoriaDetalle,
      ProgramadorProgramador,
      ProgramadorNuevaClase,
      Icon
    },
    data () {
      return {
        rightPanel : true,
    		leftPanel : true,
        dia_actual : null,
        hora_actual : null,
        nuevo_agendamiento : {
          dia: null,
          hora: null,
          tipo_solicitud : null,
          tipo_clase : null
        },
        nueva_clase: {
          dia: null,
          hora: null,
          tipo_clase : null
        },
        agendando : false,
        creando_clase: false
      }
    },
    mounted () {
      if(!this.agenda_disponible){
        this.fetchAgendaDisponible()
      }
      if(!this.cursos){
        this.fetchCursos()
      }
      if(!this.profesores || (this.profesores && this.profesores.length==0)){
        this.fetchProfesores()
      }
      if(!this.salones || (this.salones && this.salones.length==0)){
        this.fetchSalones()
      }
    },
    methods:{
      ...mapActions({
        fetchAgendaDisponible: 'asw/fetchAgendaDisponible',
        fetchCursos : 'asw/fetchCursos',
        fetchClases : 'clases/fetchClases',
        fetchClasesXMarca : 'clases/fetchClasesXMarca',
        fetctNovedades: 'docentes/fetchNovedades', 
        fetchProfesores : 'docentes/fetchLista',
        fetchSalones : 'salones/fetchLista',
        fetchTutoriasxFecha : 'tutorias/fetchTutoriasxFecha',
        fetchAgendasxFecha : 'tutorias/fetchAgendasxFecha',
        generarParcial : 'clases/generarParcial'
      }),
      ...mapMutations({
        nuevaClase: 'clases/nuevaClase',
      }),
      toogleRightPanel(){
        this.rightPanel = !this.rightPanel
      },
      edit(){

      },
      procesarNuevoAgendamiento(){
        this.nuevo_agendamiento.dia = this.dia_actual,
        this.nuevo_agendamiento.hora = this.hora_actual,
        this.nuevo_agendamiento.tipo_solicitud = null,
        this.nuevo_agendamiento.tipo_clase = null
        this.agendando = true
      },
      procesarNuevaClase(){
        this.nueva_clase.dia = this.dia_actual,
        this.nueva_clase.hora = this.hora_actual,
        this.nueva_clase.tipo_clase = null
        this.creando_clase = true
      },
      cambiarDia(value){
        this.dia_actual = value
        this.recargarTutorias()
      },
      nueva(){
        let now = new Date()
        let candidato = {
          profesor_id:-1,
          curso_id: -1,
          salon_id: -1,
          fecha:this.hora_actual.marca_tiempo.split('T')[0],
          hora:this.hora_actual.marca_tiempo.split('T')[1],
          tipo_clase:'',
          id_temporal: now.getTime()
        }
        this.nuevaClase({marca:this.hora_actual.marca_tiempo,candidato:candidato})

      },
      generar(){
        //console.log('Generando automaticamente....')

        this.generarParcial({
          marca_tiempo:this.hora_actual.marca_tiempo
        }).then(()=>{

        })
      },
      
      recargarTutorias(){

        if(this.salones.length == 0){
          this.fetchSalones()
        }
        let filtro = {fecha:this.dia_actual.fecha};
        this.fetchTutoriasxFecha(filtro).then((result)=>{
        })
        this.fetchAgendasxFecha(filtro).then((result)=>{
        })
        // this.consultarNovedades(filtro);
        // this.fetchClasesXMarca(filtro)
        // .then(()=>{
        //     //OPTIMIZACION this.fetchAgendamientos().then(()=>{}) 
            
        // })
      },
      consultarNovedades(filtro) {
        this.fetctNovedades(filtro)
        .then((result)=>{
          console.log(result);
        })
      },
      reorganizar(){
        let payload = {
          fecha:this.dia_actual.fecha,
          hora:this.hora_actual.hora
        }

        Vue.http.post('agendamientos/reorganizar',payload).then(
            response =>{}
          ).catch(response=>{
            console.log(response)
          }).finally(response=>{
            this.recargarTutorias()
          })
      }
    },
    computed: {
      ...mapState({
        agenda_disponible: state => state.asw.agenda_disponible,
        cursos: state  => state.asw.cursos,
        clases: state => state.clases.clases,
        profesores: state => state.docentes.lista,
        salones: state => state.salones.lista,
        
        tutorias: state => state.tutorias.tutorias,
        agenda: state => state.tutorias.agenda,
        grupos:  state => state.tutorias.grupos_salones

      }),
      ...mapGetters({
        permiso: 'auth/permiso', 
      }),

      iniciado(){
        // this.agenda_disponible && this.cursos && this.clases && this.profesores && this.salones && 
    		if(this.agenda && this.tutorias && this.dia_actual && this.agenda[this.dia_actual.fecha] && this.tutorias[this.dia_actual.fecha]){
    			return true
    		}
    		return false
      },
      titulo_dia(){
        if(this.dia_actual){
          return this.dia_actual.texto
        }else{
          return 'seleccione...'
        }
        
      },
      titulo_hora(){
        if(this.hora_actual){
          return this.hora_actual.nombre_corto
        }else{
          return 'seleccione...'
        }
        
      },
      titulo(){
        if(this.dia_actual &&  this.hora_actual){
          return this.dia_actual.texto+' '+this.hora_actual.nombre_corto
        }else{
          return 'seleccione...'
        }
        
      },
      tabActivo(){
        if(this.dia_actual &&  this.hora_actual){
          return this.dia_actual.fecha+'T'+this.hora_actual.hora
        }else{
          return null
        }
      },
    }
  }
</script>

<style scope>
.izquierda{
	padding-bottom: 30px
}
</style>